import React from 'react';
import Icon from '@components/core-components/icon';

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  qrCodeImage: string | null;
  twoFactorSetupSecret: string | null;
  loading: boolean;
  error: string | null;
}

const QRcodePopup: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  qrCodeImage,
  // twoFactorSetupSecret,
  // loading,
  // error,
}) => {
  if (!isOpen) return null;
  const steps = [
    <>
      Download the authenticator app from{' '}
      <a
        className="text-primary"
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
        rel="noopener noreferrer"
      >
        Google Play
      </a>{' '}
      /{' '}
      <a
        className="text-primary"
        target="_blank"
        href="https://apps.apple.com/us/app/google-authenticator/id388497605"
        rel="noopener noreferrer"
      >
        Apple Store
      </a>{' '}
      .
    </>,
    'Select add account with qr code to scan the qr code given here.',
    'Use the token generated by the app in the code section.',
  ];
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div className="bg-white rounded-2xl shadow-xl w-[596px] gap-8 py-10 px-11 flex flex-col items-center text-center relative">
        <Icon
          iconName="closeGray"
          svgProps={{ width: 32, height: 32 }}
          className="absolute top-4 right-4 cursor-pointer"
          onClick={onClose}
        />
        <div className="rounded-md border border-gray-400">
          {qrCodeImage && <img src={qrCodeImage} alt="" className="rounded-md" />}
        </div>
        <div className="flex flex-col gap-5 text-left w-full">
          <h1 className="font-bold text-xl">Steps you need to do;</h1>
          {steps.map((step, index) => (
            <p className="text-gray-600 leading-4" key={index}>
              {index + 1}.{step}
            </p>
          ))}
        </div>
        <h2 className="text-gray-600 leading-4 text-left w-full">Stay Safe, Stay Blessed...</h2>

        <button
          onClick={onClose}
          className="w-full h-10 rounded-lg bg-primary text-white font-bold hover:bg-primary-dark transition"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default QRcodePopup;
